module.exports = __webpack_public_path__ + "static/media/Icon 5.1f313718.jpeg";